/* eslint camelcase: "off" */
import ENDPOINTS from 'constants/endpoints.constants';
import { privateFetcher } from 'services';
import APIError from 'exceptions/APIError';

export const fetchCampaignsPreviewMode = async (
  orgId: number,
  campaignUuid: string,
): Promise<{
  data: {
    promotion_layout: string;
    campaigns: any[];
  };
}> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/${orgId}/campaigns/${campaignUuid}/`;
    const { data } = await privateFetcher.get(url);
    return data;
  } catch (error) {
    if (error.response) throw new APIError(error.response.data?.message, error);
    throw error;
  }
};

export const fetchCampaignLiveMode = async (
  orgId: number,
  params: any,
): Promise<{
  data: {
    promotion_layout: string;
    campaigns: any[];
  };
}> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/${orgId}/campaigns/running/`;
    const { data } = await privateFetcher.post(url, params);
    return data;
  } catch (error) {
    if (error.response) throw new APIError(error.response.data?.message, error);
    throw error;
  }
};
